import dayjs from "dayjs";

import { formatIdentifier } from "@/utils/formatIdentifier";
import { phoneFormat } from "@/utils/formatPhone";
import { addressConcat } from "@/utils/adreessConcat";
import { getAge } from "@/utils/dateUtil";
import { DetailedCitizenAttendancesIndicatorC7Data } from "@/services/esus/indicator/esf/c7/getDetailedCitizensAttendancesIndicatorC7";

import { TimeLine, TimeLineContent } from "@/components/TimeLine";
import { IndicatorEsfC7CitizenAttendancesHistoryItem } from "./IndicatorEsfC7CitizenAttendancesHistoryItem";
import { IndicatorEsfC7CitizenAttendancesHistoryInfo } from "./IndicatorEsfC7CitizenAttendancesHistoryInfo";

type IndicatorEsfC7CitizenAttendancesHistoryProps = {
	citizenWithAttendances: DetailedCitizenAttendancesIndicatorC7Data;
};

export function IndicatorEsfC7CitizenAttendancesHistory({
	citizenWithAttendances,
}: Readonly<IndicatorEsfC7CitizenAttendancesHistoryProps>) {
	const indicatorEsfC7CitizenHistoryInfo = {
		fullName: citizenWithAttendances.fullName ? citizenWithAttendances.fullName : "N/A",
		birthdate: citizenWithAttendances.birthdate
			? dayjs(citizenWithAttendances.birthdate).format("DD/MM/YYYY")
			: "N/A",
		age: citizenWithAttendances.birthdate ? getAge(citizenWithAttendances.birthdate) : "N/A",
		document: citizenWithAttendances.cpf
			? formatIdentifier(citizenWithAttendances.cpf)
			: citizenWithAttendances.cns ?? "",
		motherName: citizenWithAttendances.motherName ?? "",
		phone: citizenWithAttendances.phone ? phoneFormat(citizenWithAttendances.phone) : "",
		address:
			addressConcat(
				citizenWithAttendances.street,
				citizenWithAttendances.houseNumber,
				citizenWithAttendances.neighborhood
			) ?? "",
	};

	return (
		<>
			<IndicatorEsfC7CitizenAttendancesHistoryInfo {...indicatorEsfC7CitizenHistoryInfo} />
			<TimeLine
				timeLineTitle="Consultas"
				timeLineContents={(citizenWithAttendances.attendances ?? []).map<TimeLineContent>(
					(attendance) => {
						return {
							content: (
								<IndicatorEsfC7CitizenAttendancesHistoryItem
									attendance={attendance}
								/>
							),
							eventDate: attendance.date
								? dayjs(attendance.date).format("DD/MM/YYYY")
								: "N/A",
						};
					}
				)}
			/>
		</>
	);
}
